import TrackingMap from 'components/elements/maps/TrackingMap'
import { CONFIRM_MAP_OPTIONS, LocationConfirmProps } from 'constants/map'
import React from 'react'
import styled from 'styled-components'

/**
 * 地図表示確認用コンテンツ
 */
const MapConfirmContent: React.FC<MapConfirmContentProps> = (props) => {
  return (
    <MapConfirmContentArea>
      <MapArea onClick={props.onMapClick}>
        <TrackingMap
          defaultCenter={{
            lat: props.lat,
            lng: props.lng,
          }}
          markers={[
            {
              component: props.component,
              lat: props.lat,
              lng: props.lng,
            },
          ]}
          fixed
          height={'120px'}
          options={CONFIRM_MAP_OPTIONS}
        />
      </MapArea>
      <LocationTextArea>
        {props.locationName && (
          <LocationNameArea bold={props.boldLocationText}>
            【{props.locationName}】
          </LocationNameArea>
        )}
        <LocationAddressArea bold={props.boldLocationText}>
          {props.address}
        </LocationAddressArea>
      </LocationTextArea>
    </MapConfirmContentArea>
  )
}

export type MapConfirmContentProps = LocationConfirmProps & {
  component: React.ReactNode
  boldLocationText?: boolean
  onMapClick?: () => void
}
const MapConfirmContentArea = styled.div`
  display: flex;
  align-items: center;
`

const MapArea = styled.div`
  width: 120px;
`

const LocationTextArea = styled.div`
  flex: 1;
`

const LocationNameArea = styled.div<{ bold?: boolean }>`
  margin-bottom: 13px;
  padding-top: 11px;
  padding-left: 16px;
  ${(props): string => (props.bold ? 'font-weight: 600;' : '')};
`
const LocationAddressArea = styled.div<{ bold?: boolean }>`
  padding-left: 16px;
  font-size: 14px;
  ${(props): string => (props.bold ? 'font-weight: 600;' : '')};
`

export default React.memo<MapConfirmContentProps>(MapConfirmContent)
